import Clipboard from 'clipboard/dist/clipboard.min.js';

(function () {
  var clipboard = new Clipboard('.btn-clipboard');

  clipboard.on('success', function (e) {
    if (!e.trigger) return;

    var iconCopy = e.trigger.querySelector('.icon-copy');
    var iconCopied = e.trigger.querySelector('.copied-icon');

    if (!iconCopy && !iconCopied) return;

    iconCopied.removeAttribute('hidden');

    iconCopy.setAttribute('hidden', true);

    e.clearSelection();
  });
})();
